import { common } from '../../classes/common';
import { viewerService } from '../../classes/viewer/viewerService';

import { workArea as viewerWorkArea } from './workArea';

export const thumbArea = {

  blobThumb: [],

  idDOM: '#work-area-view-left',

  element: function () {

    return jQuery(thumbArea.idDOM);
  },

  clear: function () {

    thumbArea.element().empty();

  },

  loading: function () {

    thumbArea.clear();
    thumbArea.element().append(common.loading.element());

  },

  hide: function () {

    thumbArea.element().hide();

  },

  show: function () {

    thumbArea.element().show();

  },

  resize: function () {

    var thumbHeight = ((jQuery(window).height()) - (common.headerAndContextBarHeight));
    jQuery('#miniatura-preview').css({ height: thumbHeight });

  },

  disposeBlobs: function () {

    thumbArea.blobThumb.forEach(function (el) {
      var URL = window.URL || window.webkitURL;
      URL.revokeObjectURL(el.blob);
      el.blobObject = null;
    });
    thumbArea.blobThumb = [];

  },

  getElementSelected: function () {

    return jQuery(".miniatura-preview-item.selected");
  },

  getElementsSelected: function () {

    return jQuery(".miniatura-preview-item.selected");
  },

  getElementThumbSelected: function () {

    return jQuery(".miniatura-preview-item.selected .miniatura-preview-item-image");
  },

  getElementByOrder: function (order) {

    return jQuery('.miniatura-preview-item[data-ordem=' + parseInt(order) + ']');
  },

  getElementByPageIdAndOrder: function (id, order) {

    return jQuery('.miniatura-preview-item[data-pageid=' + parseInt(id) + '][data-ordem=' + parseInt(order) + ']');
  },

  getElementByPageIdAndOrderMultipage: function (id, ordemMultiPage) {

    return jQuery('.miniatura-preview-item[data-pageid=' + parseInt(id) + '][data-ordemMultiPage=' + parseInt(ordemMultiPage) + ']');
  },

  getElementThumbByPageIdAndOrder: function (id, order) {

    return jQuery('.miniatura-preview-item[data-pageid=' + parseInt(id) + '][data-ordem=' + parseInt(order) + '] .miniatura-preview-item-image');
  },

  getElementSelectedImage: function () {

    return thumbArea.getElementSelected().find('img').clone();
  },

  setElementSelectedByOrder: function (order) {

    thumbArea.getElementSelected().removeClass('selected');
    thumbArea.getElementByOrder(order).addClass('selected');

  },

  setAtrribLoadedElemet: function (id, ordemMultiPage) {

    var element = thumbArea.getElementByPageIdAndOrderMultipage(id, ordemMultiPage);

    if (element === null || element === undefined || element.length === 0) {

      setTimeout(function () { 
        thumbArea.setAtrribLoadedElemet(id, ordemMultiPage);
      }, 500);

    }
    else {
      thumbArea.getElementByPageIdAndOrderMultipage(id, ordemMultiPage).attr('data-loaded', true);
    }
  },

  getAtrribLoadedElemet: function (id, ordemMultiPage) {

    return thumbArea
      .getElementByPageIdAndOrderMultipage(id, ordemMultiPage)
      .attr('data-loaded') === 'true';

  },

  loadThumbBlob: function (id, ordemMultiPage, $imageContainer, quantidadePaginas) {

    const payload = {
      id: id,
      ordem: ordemMultiPage,
      marcacoes: true,
      token: window.lsViewerToken
    };

    viewerService.getPageThumb(payload)
      .then((blob) => {
        
        var URL = window.URL || window.webkitURL;
        var srcUrl = URL.createObjectURL(blob);

        var element = document.createElement("img");
        element.src = srcUrl;
        element.setAttribute('type', 'image/jpeg');

        $imageContainer.empty();
        $imageContainer.append(element);

        if (quantidadePaginas > 1) {
          var $elementNumberPages = $('<div class="miniatura-preview-item-pages"><i class="material-icons">&#xE14D;</i>' + quantidadePaginas + '</div>');
          $imageContainer.append($elementNumberPages);
        }

        thumbArea.blobThumb.push({ 
          id: parseInt(id), 
          ordemMultiPage: parseInt(ordemMultiPage), 
          blob: srcUrl, 
          blobObject: blob 
        });

      }).catch((failData) => {

        $imageContainer.empty();
        common.errorHandler(failData);

      });

  },

  thumbClickEvent: function (evt, element, $miniaturaItem, documentSummary) {
    $(".miniatura-preview-item.selected").removeClass('selected');
    $miniaturaItem.addClass('selected');

    let blobLoaded = thumbArea.getAtrribLoadedElemet(element.id, element.ordemMultiPage);

    if (!blobLoaded) {
      setTimeout(function () { 
        thumbArea.thumbClickEvent(evt, element, $miniaturaItem, documentSummary); 
      }, 1000);
    }
    else {
      viewerWorkArea.loadPage(element.id, element.tipo, element.extensao, element.isMultiPage, element.ordemMultiPage);
      viewerWorkArea.toolbarPage.navLabelTool.updateLabel(element.ordem, documentSummary.total);
    }
  },

  createThumbs: function (documentSummary) {

    thumbArea.disposeBlobs();

    var $miniaturas = $('<div id="miniatura-preview"></div>');
    var i = 0;

    var $miniaturaScroll = null;

    documentSummary.paginas.forEach(function (element) {

      var $miniaturaItem = $('<div class="miniatura-preview-item"></div>');

      $miniaturaItem.attr('data-docid', documentSummary.id);
      $miniaturaItem.attr('data-doccertdigital', documentSummary.assinado);
      $miniaturaItem.attr('data-pageid', element.id);
      $miniaturaItem.attr('data-tipo', element.tipo);
      $miniaturaItem.attr('data-ordem', element.ordem);
      $miniaturaItem.attr('data-ordemMultiPage', element.ordemMultiPage);
      $miniaturaItem.attr('data-extensao', element.extensao);
      $miniaturaItem.attr('data-ismultipage', element.isMultiPage);
      $miniaturaItem.attr('data-quantidade-paginas', element.quantidadePaginas);
      $miniaturaItem.attr('data-pagesize', element.pageSize);
      $miniaturaItem.attr('data-loaded', false);

      var $miniaturaItemNumber = $('<div class="miniatura-preview-item-number"></div>');
      $miniaturaItemNumber.html(element.ordem);
      $miniaturaItem.append($miniaturaItemNumber);

      var $miniaturaItemImage = $('<div class="miniatura-preview-item-image"></div>');
      $miniaturaItemImage.html(common.loading.element());
      $miniaturaItemImage.on('click', function (evt) {

        thumbArea.thumbClickEvent(evt, element, $miniaturaItem, documentSummary);
        
      });

      thumbArea.loadThumbBlob(element.id, element.ordemMultiPage, $miniaturaItemImage, element.quantidadePaginas);

      viewerWorkArea.loadPageBlob(element.id, element.ordemMultiPage, element.pageSize);

      if (i === 0) {

        $miniaturaItemImage.trigger('click');

      }

      $miniaturaItem.append($miniaturaItemImage);
      $miniaturas.append($miniaturaItem);

      i++;
    });

    thumbArea.clear();
    thumbArea.element().append($miniaturas);
    thumbArea.resize();

  },

  getElementByPageId: function (id) {

    return jQuery('.miniatura-preview-item[data-pageid=' + parseInt(id) + ']');
  },

  getElementThumbByPageId: function (id) {

    return jQuery('.miniatura-preview-item[data-pageid=' + parseInt(id) + '] .miniatura-preview-item-image');
  },

  getAtrribDocumentIdElementSelected: function () {

    return parseInt(thumbArea.getElementSelected().attr('data-docid'));

  },

  getAtrribPageIdElementSelected: function () {

    return parseInt(thumbArea.getElementSelected().attr('data-pageid'));

  },

  getAtrribTypeElementSelected: function () {

    return parseInt(thumbArea.getElementSelected().attr('data-tipo'));

  },

  getAtrribExtensionElementSelected: function () {

    return parseInt(thumbArea.getElementSelected().attr('data-extensao'));

  },

  getAtrribOrdemMultiPageElementSelected: function () {

    return parseInt(thumbArea.getElementSelected().attr('data-ordemmultipage'));

  },

};
